import UnitData from "@/http/data/unit-data";

export default class UnitState {
    isInitialized = false;
    selectedUnitId: null|string = null;
    units: UnitData[] = [];
}